import React, { useState } from "react";
import IconButton from "./IconButton";
import HomeIcon from "./Icons/HomeIcon";
import DocumentsIcon from "./Icons/DocumentsIcon";
import DocumentsBigIcon from "./Icons/DocumentsBigIcon";
import PagosIcon from "./Icons/PagosIcon";
import DataIcon from "./Icons/DataIcon";
import StatusField from "../GreyRectangles/StatusField";
import GreyCardVertical from "../GreyRectangles/GreyCardVertical";
import "./Resume.css";
import InfoCard3 from "../GreyRectangles/InfoCard3";

import Qr from "../Images/QR.png";
import DownloadAppQR from "../DownloadApp";

import { SpecificBooking, UserBooking, UserData, UserContract, PostInstallationDocuments } from "../../../../types/responseTypes";
//import DailyProdCard from "../Charts/DailyProdCard";
import PreInstallationCard from "./PreInstallationCard";
import BaseStatisticsCard from "../GreyRectangles/BaseStatisticsCard";

type TabType = "inicio" | "data" | "pagos" | "documentos" ;

interface ResumeBarEntreVisitaInstallProps {
  specificBooking: SpecificBooking;
  userData: UserData;
  userBooking: UserBooking;
  userContract: UserContract | null;
  installationDocuments?: PostInstallationDocuments | null;
}

const ResumeBarEntreVisitaInstall: React.FC<ResumeBarEntreVisitaInstallProps> = ({
  userData, 
  userBooking, 
  specificBooking, 
  userContract,
  installationDocuments,
}) => {

  console.log("ResumeBarEntreVisitaInstall - SPECIFIC BOOKING: ", specificBooking);
  const statistics = {
    totalPower: specificBooking.totalPower, // kW
    amountSolarPanels: specificBooking.amountSolarPanels, // cantidad de paneles
    SolarPanelsPower: specificBooking.solarPanel.power, // kW
    inverterQuantity: specificBooking.inverterQuantity, // cantidad de inversores
    inverterPower: specificBooking.inverterPower, // kW
  };

  const [activeTab, setActiveTab] = useState<TabType>("inicio");
  const handleSetActiveTab = (tab: TabType) => { setActiveTab(tab) };

  // Datos para StatusCard
  const estado = "En proceso de instalación"; // "Parcial" => circulo amarillo, "Operativo" => circulo verde (Otra cosa => rojo)
  //const produciendo = (101.51).toString(); // kWh
  //const consumiendo = (50).toString(); // kWh



  const findDocumentUrl = (where: string, name: string) => {
    // si name no es encontrado, retorna undefined y el boton deja de ser clickeable
    if (where === "installationDocs") {
      return installationDocuments?.installationDocuments.find(doc => doc.name === name)?.url;
    } else if (where === "contract") {
      return userContract?.documents.find(doc => doc.name === name)?.url;
    } 
    return undefined;
  };
  
  //const linkToPropuesta = `https://ruuf.cl/proposal/booking/${userBooking.bookingId}`; // Botón revisar propuesta
  //const linkToCredit = findDocumentUrl("contract", "contrato_creditu");
  const linkToPrenda = findDocumentUrl("contract", "prenda");
  const linkToPagare = findDocumentUrl("contract", "pagare");
  const linkToMandato = findDocumentUrl("contract", "mandato");
  const linkToCompraVenta = findDocumentUrl("contract", "compraventa");
  const linkToInverter = specificBooking.inverter.datasheetUrl; 
  const linkToPaneles = specificBooking.solarPanel.datasheetUrl;
  const linkToConnectionWithEnel = findDocumentUrl("installationDocs", 'Respuesta Solicitud de Conexión');
  const linkToCertificate = findDocumentUrl("installationDocs", ''); //"Ver documento Aprobación SEC"
  
  const openLink = (link: string | undefined) => {
    console.log("ResumeBarPostTermino - openLink - link", link);
    if (link) {
      const formattedLink = link;//encodeURI(link);
      window.open(formattedLink, "_blank");
    }
  }; 

  return (
    <div>
      <div className="ResumeBar">
        <IconButton
          label="Inicio"
          icon={<HomeIcon />}
          isActive={activeTab === "inicio"}
          onClick={() => handleSetActiveTab("inicio")}
        />
        <IconButton
          label="Data"
          icon={<DataIcon />}
          isActive={activeTab === "data"}
          onClick={() => handleSetActiveTab("data")}
        />
        <IconButton
          label="Pagos"
          icon={<PagosIcon />}
          isActive={activeTab === "pagos"}
          onClick={() => handleSetActiveTab("pagos")}
        />
        <IconButton
          label="Documentos"
          icon={<DocumentsIcon />}
          isActive={activeTab === "documentos"}
          onClick={() => handleSetActiveTab("documentos")}
        />
      </div>

      <div>
        {activeTab === "inicio" && (
          <div className="justify-center">

            <BaseStatisticsCard specificBooking={specificBooking} />

            <GreyCardVertical>
              <div className="self-stretch h-full p-2 bg-white rounded-3xl flex justify-center gap-10 flex">
                {statistics ? (
                    <StatusField label="Estado" value={estado}/>
                ) : (
                  <p>Cargando estadísticas...</p>
                )}
              </div>
            </GreyCardVertical>

            <PreInstallationCard />
          </div>
        )}

        {activeTab === "data" && (
          <DownloadAppQR
            title="Descarga la app"
            description="Escanea este código QR para descarga la app en tu celular y ver toda la información disponible"
            qrImage={Qr}
          />
        )}

        {activeTab === "pagos" && (
          <DownloadAppQR
            title="Descarga la app"
            description="Escanea este código QR para descarga la app en tu celular y ver toda la información disponible"
            qrImage={Qr}
          />
        )}

        {activeTab === "documentos" && (
          <div>
            {/* Agregar cada InfoCard según la imagen */}
            <InfoCard3
              logo={<DocumentsBigIcon />}
              title="Compraventa"
              subtitle="Contrato"
              buttonText={ linkToCompraVenta ? "Ver" : "No disp."}
              onButtonClick={() => openLink(linkToCompraVenta)}
            />
            <InfoCard3
              logo={<DocumentsBigIcon />}
              title="Mandato"
              subtitle="Contrato"
              buttonText={ linkToMandato ? "Ver" : "No disp."}
              onButtonClick={() => openLink(linkToMandato)}
            />
            <InfoCard3
              logo={<DocumentsBigIcon />}
              title="Pagaré"
              subtitle="Contrato"
              buttonText="Ver"
              onButtonClick={() => openLink(linkToPagare)}
            />
            <InfoCard3
              logo={<DocumentsBigIcon />}
              title="Prenda"
              subtitle="Contrato"
              buttonText={ linkToPrenda ? "Ver" : "No disp."}
              onButtonClick={() => openLink(linkToPrenda)}
            />
            <InfoCard3
              logo={<DocumentsBigIcon />}
              title="Aprobación SEC"
              subtitle="Certificado"
              buttonText={ linkToCertificate ? "Ver" : "No disp."}
              onButtonClick={() => openLink(linkToCertificate)}
            />
            <InfoCard3
              logo={<DocumentsBigIcon />}
              title="Conexión con Enel"
              subtitle="Contrato"
              buttonText={ linkToConnectionWithEnel ? "Ver" : "No disp."}
              onButtonClick={() => openLink(linkToConnectionWithEnel)}
            />
            <InfoCard3
              logo={<DocumentsBigIcon />}
              title="Paneles"
              subtitle="Ficha técnica"
              buttonText={ linkToPaneles ? "Ver" : "No disp."}
              onButtonClick={() => openLink(linkToPaneles)}
            />
            <InfoCard3
              logo={<DocumentsBigIcon />}
              title="Inversor"
              subtitle="Ficha técnica"
              buttonText={ linkToInverter ? "Ver" : "No disp."}
              onButtonClick={() => openLink(linkToInverter)}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ResumeBarEntreVisitaInstall;
